import React from 'react';

import { DialogContent, IconButton } from '@mui/material';

// https://github.com/akiran/react-slick
import Slider from 'react-slick';
import { styled, css } from '@mui/material/styles';

import { IconCross } from '@maiia/design-system';
import Dialog from '@/components/molecules/Dialog/Dialog';

const StyledSlider = styled(Slider)(css`
  .slick-slide > div {
    display: flex;
    align-items: center;
    justify-items: center;
    height: calc(
      100vh - 176px
    ); // 176px is the sum of paddings and margins of parent containers, this is to make sure the slider will take all available remaining height

    img {
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
  }
`);

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
};

type Props = {
  open: boolean;
  setOpen: (bool: boolean) => void;
  children: React.ReactNode;
};

const DialogSlider: React.FC<Props> = props => {
  const { children, open, setOpen } = props;

  const handleClose = () => setOpen(false);

  return (
    <Dialog
      className="slider-dialog"
      open={open}
      onClose={handleClose}
      onBackdropClick={handleClose}
    >
      <DialogContent className="popup__content" sx={{ borderWidth: 0 }}>
        <IconButton aria-label="close" onClick={handleClose} size="large">
          <IconCross />
        </IconButton>
        <StyledSlider {...settings}>{children}</StyledSlider>
      </DialogContent>
    </Dialog>
  );
};

export default DialogSlider;
